import {
    Button,
    CircularProgress,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    // TableHead,
    TableRow,
    Typography
} from "@mui/material";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import MainCard from "ui-component/cards/MainCard";
import {
    IconEdit,
    IconListCheck,
    IconMessage,
} from "@tabler/icons-react";
import { useTheme } from "@mui/system";
import SubCard from "ui-component/cards/SubCard";
import { useParams } from "react-router-dom";
import {
    closeCustomerEditDialog,
    getCustomerDetails,
    openCustomerEditDialog,
} from "store/app/customer-management/actions";
import { ErrorAlert } from "ui-component/custom-components/alertMessage";
import EditCustomer from "./edit";
import Chip from "ui-component/extended/Chip";
// import { IconUserSquareRounded } from "@tabler/icons-react";

const CustomerDetails = (props) => {
    const { customerDetails, errorMessage, isPending, isCustomerEditDialogOpen, userProfile } = props;
    const { email, customerName, isActive, mobileNumber, address } = customerDetails || {};
    const { userRoleName } = userProfile || {};

    const params = useParams();
    const { id } = params || {};

    useEffect(() => {
        props.getCustomerDetails(id);
    }, [id])

    const theme = useTheme();

    const handleCustomerEditOpen = () => {
        props.openCustomerEditDialog();
    }

    const handleCustomerEditClose = () => {
        props.closeCustomerEditDialog();
    }

    return (
        <>
            <Grid container>
                <Grid item md={12}>
                    <SubCard sx={{ p: 1.5, pl: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="h4">Customer Details</Typography>
                        {(!errorMessage && (userRoleName === "Administrator" || userRoleName === "Master admin")) &&
                            <Button
                                variant="contained"
                                size="small"
                                onClick={handleCustomerEditOpen}
                                startIcon={<IconEdit />}
                            >
                                Edit Customer
                            </Button>
                        }
                    </SubCard>
                </Grid>
                {errorMessage &&
                    <Grid item md={12} sx={{ mt: 1, mb: 0 }}>
                        <ErrorAlert content={errorMessage} />
                    </Grid>
                }
            </Grid>
            {isPending ?
                <Grid container alignItems={"center"} justifyContent={"center"} gap={1}>
                    <CircularProgress />
                    <Typography variant="h5" color={'primary'}> Loading...</Typography>
                </Grid>
                :
                <Grid container>
                    <Grid item md={6}>
                        <MainCard sx={{ mt: 1 }}>
                            <Grid container gap={1} sx={{ display: 'flex', alignItems: 'center' }}>
                                <IconListCheck color={theme.palette.secondary.dark} />
                                <Typography variant="h4" color={theme.palette.primary.dark}>
                                    Basic Info
                                </Typography>
                            </Grid>
                            <TableContainer sx={{ pl: 3, }}>
                                <Table size="small">
                                    <TableBody>
                                        <TableRow>
                                            <TableCell>Customer Name</TableCell>
                                            <TableCell>{customerName || "N/A"}</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Customer Status</TableCell>
                                            <TableCell>
                                                {isActive ?
                                                    <Chip label={"Active"} chipcolor="success" size="small" />
                                                    : <Chip label={"Inactive"} chipcolor="error" size="small" />
                                                }
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell>Address</TableCell>
                                            <TableCell>
                                                {address || "N/A"}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </MainCard>
                    </Grid>
                    <Grid md={6}>
                        <Grid item>
                            <MainCard sx={{ mt: 1, ml: 1 }}>
                                <Grid container alignItems={'center'} gap={1}>
                                    <IconMessage color={theme.palette.secondary.dark} />
                                    <Typography variant="h4" color={theme.palette.primary.dark}>
                                        Communication Info
                                    </Typography>
                                </Grid>
                                <TableContainer sx={{ pl: 3 }}>
                                    <Table size="small">
                                        <TableBody>
                                            <TableRow>
                                                <TableCell>Email Address</TableCell>
                                                <TableCell>{email || "N/A"}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell>Mobile Number</TableCell>
                                                <TableCell>{mobileNumber || "N/A"}</TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </MainCard>
                        </Grid>
                    </Grid>
                    {/* <Grid md={6}>
                        <Grid item>
                            <MainCard sx={{ mt: 1, ml: 1 }}>
                                <Grid container alignItems={'center'} gap={1}>
                                    <IconUserSquareRounded color={theme.palette.secondary.dark} />
                                    <Typography variant="h4" color={theme.palette.primary.dark}>
                                        Assigned User Info
                                    </Typography>
                                </Grid>
                                {customerManagedByUserList?.length > 0 ?
                                    <TableContainer sx={{ pl: 3 }}>
                                        <Table size="small">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Username</TableCell>
                                                    <TableCell>Email Address</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {customerManagedByUserList?.map((user, idx) => (
                                                    <TableRow key={idx}>
                                                        <TableCell>{user.userName}</TableCell>
                                                        <TableCell>{user.userEmail}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    :
                                    <Grid container>
                                        <Typography variant="caption" sx={{ fontSize: "13px", marginTop: "10px" }}>
                                            No user assigned to this customer.
                                        </Typography>
                                    </Grid>
                                }
                            </MainCard>
                        </Grid>
                    </Grid> */}
                </Grid >
            }

            <EditCustomer
                open={isCustomerEditDialogOpen}
                onClose={handleCustomerEditClose}
                customerDetails={customerDetails}
            />
        </>
    )
}

const mapStateToProps = (state) => ({
    customerDetails: state.customers.customerDetails,
    isPending: state.customers.isCustomerDetailsPending,
    errorMessage: state.customers.customerDetailsErrorMessage,
    isCustomerEditDialogOpen: state.customers.isCustomerEditDialogOpen,
    userProfile: state.login.userProfile,
})

const mapDispatchToProps = (dispatch) => ({
    getCustomerDetails: (id) => dispatch(getCustomerDetails(id)),
    openCustomerEditDialog: () => dispatch(openCustomerEditDialog()),
    closeCustomerEditDialog: () => dispatch(closeCustomerEditDialog()),
})

export default connect(mapStateToProps, mapDispatchToProps)(CustomerDetails);